<template>
  <Modal v-model="visible" :title="formData.id?'详情':''" width="800" class="my-modal top" :mask-closable="false" :footer-hide="true">
    <Tabs v-model="tabId" style="padding-top:15px" v-show="!formData.id">
      <TabPane label="系统工具" name="1"></TabPane>
      <TabPane label="自定义工具" name="2"></TabPane>
    </Tabs>
    <sys-module-list ref="sysModuleList" v-show="tabId==1" @success="visible=false;$emit('success')"></sys-module-list>
    <Form v-if="visible" v-show="tabId==2" ref="form" :model="formData" class="page-form less" :label-width="90" v-loading="loading">
      <FormItem label="类型" class="full" v-if="formData.id">
        <span v-if="formData.isSys==1">系统工具</span>
        <span v-else>自定义工具</span>
      </FormItem>
      <FormItem prop="img" label="图片" :rules="$units.formRule.required('请上传')">
        <uploadNew v-model="formData.imgArr" @change="imgUpload" :disabled="formData.isSys==1"></uploadNew>
        <div class="info-text">图片最大不超过500kb，仅限上传jpg/jpeg/gif/bmp/png格式，建议尺寸为500*500</div>
      </FormItem>
      <FormItem prop="name" label="名称" :rules="$units.formRule.required('请输入')">
        <Input v-model="formData.name" placeholder="请输入" :disabled="formData.isSys==1"/>
        <div class="info-text">建议2-5个字，5个字以上可能导致样式错乱</div>
      </FormItem>
      <!-- 只展业工具栏显示 -->
      <FormItem prop="description" label="显示文案" :rules="$units.formRule.required('请输入')" class="full" v-if="curTabInfo.moduleCode==='EXHIBITION_TOOLBAR'">
        <Input v-model="formData.description" placeholder="请输入" :disabled="formData.isSys==1"/>
        <div class="info-text">建议11个字以内，11个字以上可能导致样式错乱</div>
      </FormItem>
      <FormItem prop="urlType" label="类型" :rules="$units.formRule.required('请选择')" class="full">
        <RadioGroup v-model="formData.urlType">
          <Radio label="1">H5</Radio>
          <Radio label="2" style="margin-left:15px;">小程序</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem prop="url" label="链接" class="full" 
        :rules="formData.isSys==1?[$units.formRule.required('请输入')]:[$units.formRule.required('请输入'),$units.formRule.url2()]" v-if="formData.urlType==1">
        <Input v-model="formData.url" placeholder="请输入" :disabled="formData.isSys==1"/>
        <div class="info-text">链接必须以http://或https://开头</div>
      </FormItem>
      <template v-else>
        <FormItem prop="originalId" label="原始ID" :rules="$units.formRule.required('请输入')" :label-width="102">
          <Input v-model="formData.originalId" placeholder="请输入"/>
          <div class="info-text">请在微信小程序后台，设置-账号信息里获取</div>
        </FormItem>
        <FormItem prop="originalUrl" label="页面路径" :rules="$units.formRule.required('请输入')">
          <Input v-model="formData.originalUrl" placeholder="请输入"/>
          <div class="info-text">请联系开发人员或小程序服务提供商获取</div>
        </FormItem>
      </template>
      <FormItem prop="orderNum" label="排序" :rules="$units.formRule.required('请输入')">
        <Input v-model="formData.orderNum" placeholder="请输入"/>
        <div class="info-text">数字越大，越靠前</div>
      </FormItem>
      <FormItem prop="enable" label="是否启用" :rules="$units.formRule.required('请选择')" :label-width="110">
        <i-switch size="large" true-value="1" false-value="0" v-model="formData.enable" >
          <span slot="open">启用</span>
          <span slot="close">禁用</span>
        </i-switch>
      </FormItem>
      <!-- 只有个人中心显示 -->
      <FormItem prop="toolType" label="栏目" :rules="$units.formRule.required('请选择')" v-if="curTabInfo.moduleCode==='SELF_TOOLBAR'">
        <Select v-model="formData.toolType" filterable clearable transfer>
          <Option v-for="(txt,value) in all.TOOL_TYPE" :value="value" :key="value">{{ txt }}</Option>
        </Select>
      </FormItem>
      <template v-if="['START_AD','INDEX_WINDOW','INDEX_AD','BANNER','PC_INDEX_BANNER','BANNER_V2'].includes(curTabInfo.moduleCode)">
        <FormItem prop="startTime" label="开始日期">
          <DatePicker type="date" v-model="formData.startTime" format="yyyy-MM-dd" placeholder="请选择"></DatePicker>
        </FormItem>
        <FormItem prop="endTime" label="结束日期">
          <DatePicker type="date" v-model="formData.endTime" format="yyyy-MM-dd" placeholder="请选择"></DatePicker>
        </FormItem>
      </template>
    </Form>
    <div class="ivu-modal-footer" v-show="tabId==2">
      <Button type="text" @click="visible=false">取消</Button>
      <Button type="primary" @click="save">确认</Button>
    </div>
  </Modal>
</template>

<script>
import uploadNew from "@/components/commons/uploadNew";
import sysModuleList from "./sysModuleList";
export default {
  components: {uploadNew,sysModuleList},
  props: [],
  data() {
    return {
      tabId:"1",
      visible:false,
      loading:false,
      formData:{},
      curTabInfo:{},
      all:{},
    };
  },
  mounted() {
    this.all = JSON.parse(localStorage.dic)
  },
  methods: {
    save(){
      this.$refs.form.validate().then(isok=>{
        if(!isok){
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        delete formData.imgArr;
        if(!formData.toolType){
          delete formData.toolType
        }
        this.$http({
          url: this.formData.id ? "/buz/mcmMerchantModule/edit" : "/buz/mcmMerchantModule/add",
          type: "POST",
          data: formData,
          apiPermissionCode:'systemSet_10_3'
        }).then(res=>{
          this.visible = false;
          this.$notice.success(formData.id?"修改成功":"新增成功")
          this.$emit("success");
        })
        
      })
    },
    async open(data={}, curTabInfo={}){
      console.log(data)
      this.curTabInfo = curTabInfo;
      data = JSON.parse(JSON.stringify(data));
      if(data.id){
        this.tabId = '2';
        if(data.img){
          data.imgArr = [{path:data.img}];
        }
        if(data.urlType==2) {
          delete data.url;
        }
        this.formData = data;
      }else{
        this.tabId = '1';
        this.formData={
          parentModuleCode:this.curTabInfo.moduleCode,
          enable:'1',
          urlType:'1',
          imgArr:[],
        }
        this.$nextTick(()=>{
          this.$refs.sysModuleList.init(curTabInfo.moduleCode)
        })
      }
      this.visible = true;
    },
    // 上传图片
    imgUpload(){
      if(this.formData.imgArr && this.formData.imgArr[0]){
        this.$set(this.formData,"img",this.formData.imgArr[0].path)
      }
      this.$refs.form.validateField('img')
    }
  },
};
</script>
<style lang="scss" scoped>
.my-modal {
  /deep/ {
    .ivu-modal-body {
      padding-top: 0;
    }
  }
  .info-text {
    font-size: 12px;
    line-height: 1.5;
    padding-top: 5px;
    color: #ccc;
  }
}
</style>